import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, useTheme } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import { keyframes } from '@emotion/react';

interface InactivityWarningModalProps {
	open: boolean;
	countdown: number;
	onStayLoggedIn: () => void;
}

const countdownAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const InactivityWarningModal = ({ open, countdown, onStayLoggedIn }: InactivityWarningModalProps) => {
	const theme = useTheme();

	return (
		<Dialog open={open} sx={{ maxWidth: '400px', mx: 'auto' }} onClose={onStayLoggedIn}>
			<DialogTitle>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<WarningIcon sx={{ color: theme.palette.warning.main, mr: 3 }} />
					Inactivity Warning
				</Box>
			</DialogTitle>
			<DialogContent>
				<Typography variant='body1'>
					You will be logged out due to inactivity in{' '}
					<Box
						component='span'
						sx={{
							color: theme.palette.secondary.main,
							animation: `${countdownAnimation} 1s ease-in-out`,
							display: 'inline-block',
							fontSize: '1.05rem',
							fontWeight: '600',
							marginRight: '0.25rem',
						}}
					>
						{countdown}
					</Box>{' '}
					seconds.
				</Typography>
				<Typography variant='body2' sx={{ mt: 3 }}>
					Please click <b>&quot;Stay Logged In&quot;</b> to remain logged in.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={onStayLoggedIn} color='primary' variant='contained' fullWidth>
					Stay Logged In
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default InactivityWarningModal;
